import { handleActions } from 'redux-actions';
import { NOT_REQUESTED, REQUESTED, FAILED, SUCCEEDED } from 'forms-utils-lib/RequestState';
import { REQUEST_TEAMS, RECEIVE_TEAMS, FAIL_GETTING_TEAMS } from 'ui-forms-editor-automation-lib/actions/fetchTeams';
export const INITIAL_STATE = {
  teams: [],
  requestState: NOT_REQUESTED
};
export default handleActions({
  [REQUEST_TEAMS]: state => Object.assign({}, state, {
    requestState: REQUESTED
  }),
  [RECEIVE_TEAMS]: (_, {
    payload
  }) => ({
    teams: payload,
    requestState: SUCCEEDED
  }),
  [FAIL_GETTING_TEAMS]: state => Object.assign({}, state, {
    requestState: FAILED
  })
}, INITIAL_STATE);